import FeatureFlagSettingsSection from '../components/FeatureFlagSettingsSection';
import { AdminSettingsRegistry } from '~/plugins/AdminSettingsRegistry';
import { isFeatureFlagAdminVisible } from '../state/adminUIVisibility';

export const registerAdminSettingsExtension = () => {
  AdminSettingsRegistry.addSection({
    id: 'feature-flags',
    title: 'featureFlag.title',
    component: FeatureFlagSettingsSection,
    order: 100,
    visible: () => isFeatureFlagAdminVisible(),
  });
};
